// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outer[data-v-fed8bf62]{margin-top:10px}.outer .nc-comp[data-v-fed8bf62]{width:100%}.outer .nc-comp[data-v-fed8bf62] ul{max-height:200px}`, "",{"version":3,"sources":["webpack://./components/modal/EditTags.vue"],"names":[],"mappings":"AACA,wBACE,eAAA,CAEA,iCACE,UAAA,CAEA,oCACE,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
